import {
  fetchOffersStart,
  fetchOffersSuccess,
  fetchOffersFailure,
} from "./reducer";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_ALL_OFFER } from "../../constants/constants";

export const getAllOffer =
  (partnerId, page = 1, pageSize = 10, status = "active", setLoading) =>
  async (dispatch) => {
    try {
      setLoading?.(true);

      dispatch(fetchOffersStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_OFFER(partnerId, page, pageSize, status),
        "GET"
      );

      dispatch(fetchOffersSuccess(response));

      setLoading?.(false);
    } catch (error) {
      setLoading?.(false);

      dispatch(fetchOffersFailure(error.message));
    }
  };